import SiteMapping from "@components/screens/siteMapping/SiteMapping";
const CustomerNumberMapping =()=>{
    return (
        <>
            <SiteMapping/>
        </>
    )
}

export default CustomerNumberMapping;